function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKPATHHOP opcode — verify routing path, filter hops, assert, write hop to __opcodes.
 */

module.exports = {
  name: 'CHECKPATHHOP',
  description: 'Verify a routing path and assert conditions over selected hop(s) after applying selection criteria.',
  exampleScript: {
    op: 'CHECKPATHHOP',
    selector: 'FIRST',
    where: [{
      field: 'value.delegation',
      operator: '==',
      value: 0,
      type: 'number'
    }],
    assert: [{
      field: 'to',
      operator: '==',
      value: 'REQUESTER'
    }],
    publickey: '<creator_publickey>',
    witness: {
      hops: [{
        to: '<publickey>',
        value: '<base64_json_payload>',
        sig: '<hex_signature>'
      }]
    }
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    if (!context.app || !context.app.crypto || typeof context.app.crypto.verifyRoutingPath !== 'function') {
      return false;
    }
    var witness = node.witness;
    if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
      return false;
    }
    var path = witness.hops;
    if (!Array.isArray(path) || path.length === 0) {
      return false;
    }
    var start_publickey = resolveRef(context, node.publickey);
    if (typeof start_publickey !== 'string' || start_publickey.length === 0) {
      return false;
    }
    var binding_hash = resolveRef(context, node.hash);
    if (typeof binding_hash !== 'string') {
      binding_hash = '';
    }
    if (context.app.crypto.verifyRoutingPath(path, start_publickey, binding_hash) !== true) {
      return false;
    }
    var decoded = [];
    var expectedFrom = start_publickey;
    for (var h = 0; h < path.length; h += 1) {
      var hop = path[h];
      if (!hop || _typeof(hop) !== 'object' || typeof hop.value !== 'string') {
        return false;
      }
      var parsed = JSON.parse(Buffer.from(hop.value, 'base64').toString('utf8'));
      decoded.push({
        from: expectedFrom,
        to: hop.to,
        sig: hop.sig,
        value: parsed
      });
      expectedFrom = hop.to;
    }
    var filtered = decoded;
    if (Array.isArray(node.where) && node.where.length > 0) {
      filtered = [];
      for (var d = 0; d < decoded.length; d += 1) {
        var _hop = decoded[d];
        var match = true;
        for (var w = 0; w < node.where.length; w += 1) {
          if (evaluateCondition(_hop, node.where[w], context) !== true) {
            match = false;
            break;
          }
        }
        if (match) {
          filtered.push(_hop);
        }
      }
    }
    if (filtered.length === 0) {
      return false;
    }
    var selected = [];
    var selector = node.selector;
    if (selector === 'FIRST') {
      selected = [filtered[0]];
    } else if (selector === 'LAST') {
      selected = [filtered[filtered.length - 1]];
    } else if (selector === 'ONLY') {
      if (filtered.length !== 1) {
        return false;
      }
      selected = [filtered[0]];
    } else if (selector === 'ANY') {
      selected = filtered;
    } else {
      return false;
    }
    if (Array.isArray(node.assert) && node.assert.length > 0) {
      var assertion_satisfied = false;
      for (var s = 0; s < selected.length; s += 1) {
        var _hop2 = selected[s];
        for (var a = 0; a < node.assert.length; a += 1) {
          var result = evaluateCondition(_hop2, node.assert[a], context);
          if (result !== true && result !== false) {
            return false;
          }
          if (result === false) {
            return false;
          }
          if (result === true) {
            assertion_satisfied = true;
          }
        }
      }
      if (!assertion_satisfied) {
        return false;
      }
    }
    var winning_hop = selected[0];
    if (!context.__opcodes) {
      context.__opcodes = {};
    }
    if (!context.__opcodes.checkpathhop) {
      context.__opcodes.checkpathhop = {};
    }
    context.__opcodes.checkpathhop.hop = {
      from: winning_hop.from,
      to: winning_hop.to,
      sig: winning_hop.sig,
      value: winning_hop.value
    };
    return true;
  }
};
function resolveRef(root, ref) {
  if (typeof ref !== 'string') {
    return ref;
  }
  var parts = ref.split('.');
  var cursor = root;
  for (var i = 0; i < parts.length; i += 1) {
    var key = parts[i];
    if (!cursor || _typeof(cursor) !== 'object' || !Object.prototype.hasOwnProperty.call(cursor, key)) {
      return ref;
    }
    cursor = cursor[key];
  }
  return cursor;
}
function evaluateCondition(hopContext, condition, context) {
  if (!condition || _typeof(condition) !== 'object') {
    return false;
  }
  var field = condition.field;
  var operator = condition.operator;
  var value = condition.value;
  var type = condition.type;
  if (typeof field !== 'string' || typeof operator !== 'string') {
    return false;
  }
  var parts = field.split('.');
  var lhs = hopContext;
  for (var i = 0; i < parts.length; i += 1) {
    if (!lhs || _typeof(lhs) !== 'object') {
      lhs = undefined;
      break;
    }
    lhs = lhs[parts[i]];
  }
  var rhs = value;
  if (typeof value === 'string' && Object.prototype.hasOwnProperty.call(context, value)) {
    rhs = context[value];
  }
  var coerce = function coerce(v) {
    if (!type) {
      return v;
    }
    if (type === 'number') {
      return Number(v);
    }
    if (type === 'string') {
      return String(v);
    }
    if (type === 'boolean') {
      if (v === true || v === false) {
        return v;
      }
      if (v === 'true') {
        return true;
      }
      if (v === 'false') {
        return false;
      }
      if (v === 1) {
        return true;
      }
      if (v === 0) {
        return false;
      }
      return false;
    }
    return v;
  };
  var left = coerce(lhs);
  var right = coerce(rhs);
  if (operator === '==') {
    return left === right;
  }
  if (operator === '!=') {
    return left !== right;
  }
  if (operator === '<') {
    return left < right;
  }
  if (operator === '<=') {
    return left <= right;
  }
  if (operator === '>') {
    return left > right;
  }
  if (operator === '>=') {
    return left >= right;
  }
  return false;
}